export const apiConstants = {
  url: "/api/orderpositions"
};
